import Button, { ButtonProps } from '@material-ui/core/Button';
import GitHubIcon from '@material-ui/icons/GitHub';
import React, { useCallback, useState } from 'react';
import Auth from '@aws-amplify/auth';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function SignInButton(
  { text = 'Sign in with GitHub', returnTo, ...props }: { text?: string, returnTo?: string } & ButtonProps,
) {
  const [loading, setLoading] = useState(false);
  const handleClick = useCallback(() => {
    setLoading(true);
    Auth.federatedSignIn({ customProvider: 'GithubProvider', customState: JSON.stringify({ returnTo }) });
  }, [returnTo]);
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={loading ? <CircularProgress color="inherit" size={20} /> : <GitHubIcon />}
      disabled={loading}
      onClick={handleClick}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {text}
    </Button>
  );
}
